module.exports = __webpack_public_path__ + "static/mailjetImage@2x-b39e70f42d23e87da56b053d69f495c5.png";